import { StyleFn } from './index'
import { buttonStyles } from './PlayPauseButton'

export type StylesKeys = 'skipButton'

export type StylesObj = {
  [key in StylesKeys]?: StyleFn
}

export type Styles = {
  skipButton: StyleFn
}

export const defaultStyles: Styles = {
  skipButton: (state: HelperState) => ({
    ...buttonStyles,
    padding: '0.6em',
    margin: '0 0.6em',
    width: '2.4em',
    height: '2.4em',
    opacity: state.disabled ? 0.7 : 1,
  }),
}

type HelperState = {
  disabled?: boolean
}
